var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cart-navigation"},[_c('div',{staticClass:"cart-navigation-header"},[_c('h5',{staticClass:"visually-hidden"},[_vm._v("Cart")]),_c('button',{staticClass:"btn-close text-reset",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeMenu}})]),_c('div',{staticClass:"cart-navigation-body"},[_vm._v(" cart here ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }